(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanon-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vanon-home')) {
    customElements.define('vanon-home', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const eventOptions = { signal: this.abortController.signal };
        const mainImage = this.querySelector('.vh-product-image');
        const thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
        const thumbnailsWrap = this.querySelector('[data-thumbnails]');
        const showImage = (url, alt) => {
          if (!mainImage || !url) return;
          mainImage.removeAttribute('srcset');
          mainImage.src = url;
          mainImage.alt = alt || '';
          thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.src === url)));
        };
        if (thumbnailsWrap) thumbnailsWrap.hidden = false;
        thumbnails.forEach(button => button.addEventListener('click', () => showImage(button.dataset.src, button.dataset.alt), eventOptions));
        const variants = this.querySelector('[data-variants]');
        const quantity = this.querySelector('[data-quantity]');
        const minus = this.querySelector('[data-decrease]');
        const plus = this.querySelector('[data-increase]');
        const add = this.querySelector('[data-add]');
        const price = this.querySelector('[data-price]');
        if (!variants || !quantity || !minus || !plus || !add) return;
        const limits = () => ({ min: Number(quantity.min) || 1, step: Number(quantity.step) || 1, max: quantity.max ? Number(quantity.max) : Infinity });
        const updateButtons = () => {
          const rule = limits();
          const value = Number(quantity.value);
          minus.disabled = !quantity.value || value <= rule.min;
          plus.disabled = value + rule.step > rule.max;
        };
        const normalizeQuantity = () => {
          const rule = limits();
          const numeric = Number(quantity.value);
          let value = Number.isFinite(numeric) ? numeric : rule.min;
          value = Math.max(rule.min, value);
          value = rule.min + Math.floor((value - rule.min) / rule.step) * rule.step;
          if (Number.isFinite(rule.max)) value = Math.min(value, rule.min + Math.floor((rule.max - rule.min) / rule.step) * rule.step);
          quantity.value = String(Math.max(rule.min, value));
          updateButtons();
        };
        const changeVariant = (changeImage) => {
          const option = variants.options[variants.selectedIndex];
          if (!option) { add.disabled = true; return; }
          if (price) price.textContent = option.dataset.price;
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          normalizeQuantity();
          if (changeImage) showImage(option.dataset.image, option.dataset.imageAlt);
        };
        minus.hidden = false;
        plus.hidden = false;
        minus.addEventListener('click', () => { normalizeQuantity(); quantity.value = String(Math.max(limits().min, Number(quantity.value) - limits().step)); updateButtons(); }, eventOptions);
        plus.addEventListener('click', () => { normalizeQuantity(); const rule = limits(); if (Number(quantity.value) + rule.step <= rule.max) quantity.value = String(Number(quantity.value) + rule.step); updateButtons(); }, eventOptions);
        quantity.addEventListener('input', updateButtons, eventOptions);
        quantity.addEventListener('change', normalizeQuantity, eventOptions);
        variants.addEventListener('change', () => changeVariant(true), eventOptions);
        changeVariant(false);
      }
      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
